/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { InteractiveComponents } from '../../../core/enums/InteractiveComponents';
import { RootState } from '../../../store/root.reducers';
import { Caret } from '../../common';

import './OverlayInteractiveLayer.scss';

const OverlayInteractiveLayer: FunctionComponent = (): JSX.Element => {
    const isCaretVisible = useSelector((state: RootState) => state.overlayDialog.isCaretVisible);
    const activeComponent = useSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    return (
        <React.Fragment>
            <Caret
                className="overlay-select-option-caret-east"
                direction={InteractiveComponents.EAST.toLocaleLowerCase()}
                visible={isCaretVisible}
                active={activeComponent === InteractiveComponents.EAST}
            />
            <Caret
                className="overlay-select-option-caret-west"
                direction={InteractiveComponents.WEST.toLocaleLowerCase()}
                visible={isCaretVisible}
                active={activeComponent === InteractiveComponents.WEST}
            />
        </React.Fragment>
    );
};

export default OverlayInteractiveLayer;
